import { rem } from 'polished';
import styled from 'styled-components';
import { TitleWithBenefitsStyled } from '../TitleWithBenefitsStyled';

export const TitleWithBenefitsStyledOV = styled(TitleWithBenefitsStyled)`
    .title {
        font-size: ${rem(30)};
        font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
    }
    .specs .specs-title {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        font-weight: ${({ theme }) => theme.fontWeights.textLight};
    }

    .benefits {
        background: none;
        padding: 0;
        .bullet-points {
            padding-left: ${rem(16)};

            .offer > svg {
                width: ${rem('22px')};
                height: ${rem('22px')};
            }
        }
        .allow-bullet-points {
            padding-left: ${rem('16px')};
        }
    }
`;
